module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navOpen),
      expression: "navOpen"
    }],
    staticClass: "overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-2"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('h1', {
    staticClass: "logo"
  }, [_vm._v("Label Interactive")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "visible-xs",
    class: _vm.hamburgerClass,
    attrs: {
      "id": "hamburger"
    },
    on: {
      "click": function($event) {
        _vm.navOpen = !_vm.navOpen;
      }
    }
  }, [_c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span'), _vm._v(" "), _c('span')]), _vm._v(" "), _c('nav', {
    staticClass: "col-sm-10",
    on: {
      "click": _vm.closeIfOpen
    }
  }, [_c('nav-links', {
    staticClass: "hidden-xs pull-right"
  }), _vm._v(" "), _c('nav-links', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.navOpen),
      expression: "navOpen"
    }],
    staticClass: "text-center mobile"
  })], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4109d926!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Nav.vue
// module id = 586
// module chunks = 2